<template>
  <BaseTemplate>
    <div class="purchase-class">
      <Title class="_title" :jpn="t('Xmarket出品リスト')" />
      <div class="search-container">
        <div class="search-bar">
          <input type="text" v-model="searchParams.freeword" @change="search(1)" />
          <button class="search-button">
            🔍
          </button>
        </div>
      </div>
      <MarketNotice />
      <MarketHeader
        :selectType="selectType"
        @changeCardType="changeCardType"
      />
      <div class="card-list">
        <MarketCardList
          v-if="cardList"
          :cardList="cardList.list"
          :cardListTitle="t('検索結果')"
          :currentUser="userDetail"
          :isMyList="true"
          isType="undecided"
          @handleBtnClick="handleBtnClick"
          @refreshList="refresh"
        />
        <BoxPager
        v-if="cardList.page && cardList.page.pages && cardList.page.pages.length > 1"
        class="box-pager"
        :totalPageCount="cardList.page.all_page"
        :currentPageCount="cardList.page.page"
        :dispBoxCount="cardList.page.pages.length"
        :pages="cardList.page.pages"
        @handlePagerClick="changeCurrentPageCount"
        @handleSquareBtnClick="changeCurrentPageCount"
      />
      </div>
      <CommonOverlay @handleOverlayClick="closeModal" class="overlay_conf"  v-if="showCardDetail" >
        <div @click.stop>
          <CommonModal @click.stop class="modal market-modal">
              <div class="card-info">
                <div class="card-info-text">
                  <MarketCardList
                    :cardList="[popupCardData]"
                    :isHistory="false"
                    :isMyList="true"
                    :currentUser="userDetail"
                    :oneSheet="true"
                    @handleBtnClick="handleBtnClick"
                  />
                </div>
                <div class="text-box">
                  <TextBox class="text-box"
                    type="number"
                    v-model="price"
                    :placeholder="t('販売価格を入力してください')"
                  />
                    <span :class="{'abroad' : userAbroad}">
                      {{ t('円') }}
                    </span>
                </div>
                <ErrorMessage
                  v-if="errorMessageCard || errorMessageMarket || errorMessageParam"
                  class="error-message"
                  :message="errorMessageCard || errorMessageMarket || errorMessageParam"
                />
              </div>
              <div class="button-area">
                <BuyButton
                  :isArrow="false"
                  :text="t('販売する')"
                  @handleSquareBtnClick="submit(popupCardData, 0)"
                />
                <div class="price-info">
                  {{ formatPriceMessage(popupCardData.min_price) }}
                  <div class="tax-info">
                    {{ t('販売手数料として10%を頂戴いたします') }}
                  </div>
                </div>
                <!-- <button class="auction-button" @click="submit(popupCardData, 1)">{{ t('オークションとしてこの価格からマーケットに出品') }}</button> -->
              </div>
          </CommonModal>
        </div>
      </CommonOverlay>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import { separateCharacterNumber } from '@/common/util/format';
import t from '@/plugins/i18n';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import MarketCardList from '@/components/organisms/MarketCardList.vue';
import Title from '@/components/molecules/Title02.vue';
import MarketHeader from '@/components/molecules/Header/MarketMyListHeader.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import MarketNotice from '@/components/atoms/MarketNotice.vue';

export default {
  name: 'MarketMyListUndecided',
  mixins: [t],
  components: {
    BaseTemplate,
    Title,
    MarketCardList,
    BoxPager,
    CommonModal,
    CommonOverlay,
    MarketHeader,
    BuyButton,
    TextBox,
    ErrorMessage,
    MarketNotice,
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },
  data() {
    return {
      searchParams: {
        freeword: '',
        card_type: null,
      },
      price_min: null,
      price_max: null,
      orderBy: '',
      pageNumber: 1,
      showCardDetail: false,
      popupCardData: {},
      price: '',
      errorMessageParam: null,
      errorMessageCard: null,
      errorMessageMarket: null,
    };
  },
  computed: {
    ...mapGetters({
      marketList: 'pending/marketList',
      resultMarketSale: 'market/resultMarketSale',
      selectType: 'cardType/cardTypeList',
      userDetail: 'user/currentUserDetail',
      currentUser: 'user/currentUser',
      myListCardType: 'market/myListCardType',
    }),
    cardList() {
      if (this.marketList) {
        return this.marketList;
      }
      return [];
    },
    userAbroad() {
      if (this.currentUser) {
        return this.currentUser.language_id !== 1;
      }
      return false;
    },
  },
  watch: {
    resultMarketSale(newResult) {
      if ((newResult.state !== 200) || (newResult.error && newResult.error.length !== 0)) {
        this.errorMessageParam = newResult.errors?.param?.[0] || null;
        this.errorMessageCard = newResult.errors?.card?.[0] || null;
        this.errorMessageMarket = newResult.errors?.market?.[0] || null;
        return;
      }
      this.showCardDetail = false;
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
      this.$store.dispatch('pending/setMarketList', {
        pageNumber: this.pageNumber,
      });
    },
  },
  created() {
    // storeからcard_typeを取得して設定
    if (this.myListCardType) {
      this.searchParams.card_type = this.myListCardType;
    }
    const pageNumber = 1;
    this.$store.dispatch('pending/setMarketList', {
      pageNumber,
      postParam: this.searchParams,
    });
    this.$store.dispatch('cardType/setCardTypeList');
  },
  methods: {
    handleBtnClick(cardItem) {
      this.popupCardData = cardItem;
      this.price = '';
      this.showCardDetail = true;
    },
    formatPriceMessage(min) {
      if (!min) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '{min}円以上の価格で出品できます。当該ガチャの販売終了後に出品されます。';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{min}', this.$options.filters.comma(min));
    },
    closeModal() {
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
      this.errorMessageParam = null;
      this.showCardDetail = false;
    },
    changeCurrentPageCount(page) {
      this.pageNumber = page;
      this.search(page);
    },
    changeCardType(mode) {
      this.searchParams.card_type = mode;
      this.search();
    },
    search(page = 1) {
      this.$store.dispatch('pending/setMarketList', {
        pageNumber: page,
        postParam: this.searchParams,
      });
    },
    refresh() {
      // 表の再取得
      this.search(1);
      // ユーザー詳細の更新
      this.$store.dispatch('user/setCurrentUser');
    },
    submit(postData, saleType) {
      if (!postData) {
        return;
      }
      const postParams = {
        user_history_card_id: postData.history_card_id,
        sale_type: saleType,
        price: this.price,
      };
      this.$store.dispatch('market/sale', { postParam: postParams });
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-class{
  width: 100%;
  min-height: 100vh;
  margin: 0 auto ;
  color: #042859;
  ._title {
    margin-top: 20px;
    max-width: 900px;
    margin: 0 auto;
  }
  //検索バーとフィルター___________________
  .search-container {
    max-width: 900px;
    // background-color: #f0f0f0;
    margin: 0 auto;
    width: 90%;
    padding: 20px 20px 10px 20px;
    text-align: center;
    .search-bar {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 5px 10px;
      position: relative;
      border: 1px solid $gray2;
      input {
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 16px;
      }
      .search-button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
  // モーダルウィンドウ______________________
  .overlay_conf{
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .market-modal {
      border: none;
      box-shadow:  0 0px 20px rgba(0, 0, 0, 1.0);
      border-radius: 10px;
      max-width: 700px;
      max-height: 90%;
      overflow-y: auto;
      padding: 20px;
      position: relative;
      .card-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        position: relative;
        .card-info-text {
          margin-top: 10px;
        }
        .text-box {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: 230px;
          margin: 0 auto; // 親幅に対して中央に配置
          font-size: 18px;
          position: relative;
          span {
            position: absolute;
            right: -25px; // inputの右端内側に表示
            pointer-events: none;
            font-weight: bold;
            &.abroad {
              right: -38px;
            }
          }
        }
      }
      .button-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        button{
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          border-radius: 50px;
          border: none;
          font-size: 16px;
          margin-bottom: 10px;
          width: auto;
        }
        .price-info {
          margin-top: 10px;
          font-size: 14px;
          color: #666;
          text-align: center;
          .tax-info {
            color: $red;
          }
        }
        .auction-button {
          padding: 10px 25px;
          background: #a1a2a2;
          color: white;
          font-weight: bold;
          border: none;
          cursor: pointer;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          @media screen and (max-width: $tabletWidth) {
            padding: 5px 15px;
          }
        }
      }
    }
  }
}
</style>
